import { useState } from "react";
import { supabase } from "../supabaseClient";

export default function EmailFixEngine({ user }) {
  const [original, setOriginal] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleOptimize = async () => {
    setLoading(true);
    setError(null);
    try {
      const resp = await fetch("/api/optimize-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ original_email: original, user_id: user.id }),
      });
      const data = await resp.json();
      if (!resp.ok) throw new Error(data.error || "Failed to optimize");
      setResult(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col md:flex-row gap-4 p-4 bg-gray-50 rounded-lg shadow">
      {/* Left panel */}
      <div className="flex-1 flex flex-col">
        <textarea
          className="w-full h-48 p-2 border rounded resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Paste your cold email here..."
          value={original}
          onChange={(e) => setOriginal(e.target.value)}
        />
        <button
          className="mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
          onClick={handleOptimize}
          disabled={loading || !original.trim()}
        >
          {loading ? "Optimizing…" : "Optimize & Fix"}
        </button>
        {error && <p className="mt-2 text-red-600">{error}</p>}
      </div>

      {/* Right panel – shown after result */}
      {result && (
        <div className="flex-1 flex flex-col space-y-4 animate-fadeIn">
          <div className="p-3 bg-green-100 rounded text-center text-lg font-semibold">
            {result.score} ➔ {result.new_score} <span className="text-green-700">↑ Score Improved!</span>
          </div>
          <div className="space-y-2">
            <h4 className="font-medium">Critical Issues</h4>
            <ul className="list-disc list-inside">
              {result.issues.map((issue, i) => (
                <li key={i}>{issue}</li>
              ))}
            </ul>
          </div>
          <div className="border p-3 rounded bg-white relative">
            <pre className="whitespace-pre-wrap break-words">{result.improved_email}</pre>
            <button
              className="absolute top-2 right-2 px-2 py-1 bg-gray-200 rounded hover:bg-gray-300"
              onClick={() => navigator.clipboard.writeText(result.improved_email)}
            >
              Copy
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

